import { render, staticRenderFns } from "./OrcamentoNovo.vue?vue&type=template&id=b3a43bdc"
import script from "./OrcamentoNovo.vue?vue&type=script&lang=js"
export * from "./OrcamentoNovo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports